import { useIntl } from 'react-intl';
import map from 'lodash/map';

import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { useGetCandidateDetails } from 'src/pages/CandidatesDetailsPage/api';

import { CandidateTabProps } from '../CandidateShiftsTab';
import CertificatesFormModal from '../CertificatesFormModal/CertificatesFormModal';
import CandidateHealthCertificate from '../CandidateHealthCertificate/CandidateHealthCertificate';
import CandidateProjectCertificate from '../CandidateProjectCertificate/CandidateProjectCertificate';

import messages from './messages';

export default function CandidateQualificationsTab({
  uuid,
}: CandidateTabProps) {
  const { formatMessage } = useIntl();

  const { data: candidate } = useGetCandidateDetails({
    uuid: uuid,
    enabled: false,
  });

  if (!candidate?.data) return null;

  const { languages, hasDrivingLicense, healthCertificates, certificates } =
    candidate.data;

  return (
    <Grid container spacing={5} p={2}>
      <Grid container flexDirection="column" spacing={1} size={12}>
        <Grid container spacing={1} alignItems="center">
          <Typography variant="h4" fontSize={20}>
            {formatMessage(messages.projectCertificates)}
          </Typography>
          <CertificatesFormModal uuid={uuid!} certificates={certificates} />
        </Grid>
        <Grid container spacing={2} alignItems="center">
          {certificates?.length > 0 ? (
            map(certificates, (certificate) => (
              <CandidateProjectCertificate
                userUuid={uuid!}
                key={certificate?.id}
                certificate={certificate}
              />
            ))
          ) : (
            <Typography variant="h5">-</Typography>
          )}
        </Grid>
      </Grid>
      <Grid container flexDirection="column" spacing={1} size={12}>
        <Typography variant="h4" fontSize={20}>
          {formatMessage(messages.language)}
        </Typography>
        <Grid container spacing={3} alignItems="center">
          {map(languages, (language) => (
            <Typography
              key={language?.id}
              variant="h5"
              textTransform="capitalize"
            >
              {language?.name}
            </Typography>
          ))}
        </Grid>
      </Grid>
      <Grid container flexDirection="column" spacing={1} size={12}>
        <Typography variant="h4" fontSize={20}>
          {formatMessage(messages.driverLicense)}
        </Typography>
        <Typography variant="h5" textTransform="capitalize">
          {hasDrivingLicense
            ? formatMessage(messages.available)
            : formatMessage(messages.notAvailable)}
        </Typography>
      </Grid>
      <Grid container flexDirection="column" spacing={1} size={12}>
        <Typography variant="h4" fontSize={20}>
          {formatMessage(messages.healthCertificates)}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          {healthCertificates?.length > 0 ? (
            map(healthCertificates, (certificate, index) => (
              <CandidateHealthCertificate
                key={certificate?.id}
                certificate={certificate}
                index={index}
              />
            ))
          ) : (
            <Typography variant="h5">-</Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
